export const SET_PATHS = 'SET_PATHS';
export const SET_METHOD = 'SET_METHOD';
export const SET_INTEGRATION_UUID = 'SET_INTEGRATION_UUID';
export const SET_INTEGRATION_PREVIEW = 'SET_INTEGRATION_PREVIEW';
export const SET_NUCAL_COMPONENT = 'SET_NUCAL_COMPONENT';
export const SET_FIELDS = 'SET_FIELDS';

export const SET_PARAMETERS_NAME = 'SET_PARAMETERS_NAME';
export const SET_PARAMETERS_PARAMS = 'SET_PARAMETERS_PARAMS';
